import Request from 'utils/request.js';

const MANAGEMENT_BASE_URL = 'management/specialists';

export const getSpecialists = () => Request.get(`${MANAGEMENT_BASE_URL}`);

const toFormData = (data = {}) => {
  const form = new FormData();

  if (data.name != null) form.append('name', data.name);
  if (data.phone != null) {
    form.append('phone', data.phone);
    form.append('phoneNumber', data.phone);
  }
  if (typeof data.active !== 'undefined') form.append('active', String(Boolean(data.active)));
  if (data.image instanceof File) form.append('image', data.image);

  return form;
};

export const createSpecialist = (data) =>
  Request.post(`${MANAGEMENT_BASE_URL}`, toFormData(data), {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const updateSpecialist = (id, data) =>
  Request.put(`${MANAGEMENT_BASE_URL}/${id}`, toFormData(data), {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const updateSpecialistsOrders = (data) =>
  Request.post(`${MANAGEMENT_BASE_URL}/update-orders`, data);
